import DOMPurify from "dompurify";

// Backend source links open in a new tab; DOMPurify drops `target` unless explicitly allowed.
const CONFIG = { USE_PROFILES: { html: true }, ADD_ATTR: ["target"] };

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

/** HTML coming from the AI or from document text is untrusted: strip scripts/handlers, keep formatting. */
export const sanitizeHtml = (html: string | null | undefined): string =>
  DOMPurify.sanitize(html || "", CONFIG);
